import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../http.service';
import { HttpRequestHandler } from '../../models/http-model';

const HEADERS = {};
@Injectable()
export class PaymentService {
  static ENV = environment;

  constructor(
    private httpService: HttpService
  ) { }

  public getInvoice(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(PaymentService.ENV.environment.API.invoice, data, httpRequesthandler);
  }

  public states(httpRequesthandler: HttpRequestHandler) {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get('assets/json/states.json', httpRequesthandler);
  }

  public getBankList(httpRequesthandler: HttpRequestHandler) {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${PaymentService.ENV.environment.PAYU.bancos}`, httpRequesthandler);
  }

  public pay(data: any, httpRequesthandler: HttpRequestHandler) {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(PaymentService.ENV.environment.PAYU.pagos, data, httpRequesthandler);
  }

  public getDetailTransaction(data: any, httpRequesthandler: HttpRequestHandler) {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(PaymentService.ENV.environment.PAYU.transaction_detail, data, httpRequesthandler);
  }

  public getMyIp(httpRequesthandler: HttpRequestHandler) {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(PaymentService.ENV.environment.API.myip, httpRequesthandler);
  }

  public sendEmail(data: any, httpRequesthandler: HttpRequestHandler) {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(PaymentService.ENV.environment.PAYU.send_transaction_detail, data, httpRequesthandler);
  }

  public getVaucher(data:any, httpHandler : HttpRequestHandler ){
    httpHandler.headers = HEADERS;
    this.httpService.post(PaymentService.ENV.environment.API.summary_transacction, data, httpHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/payment/payment.service.ts